// @ts-nocheck
import { Trash2 } from 'lucide-react'

export default function TimeSlotEditor({ timeSlot, onChange, onRemove, canRemove }) {
  const handleStartChange = (e) => {
    onChange({ ...timeSlot, start: e.target.value })
  }

  const handleEndChange = (e) => {
    onChange({ ...timeSlot, end: e.target.value })
  }

  return (
    <div className="flex items-center gap-2">
      <input
        type="time"
        value={timeSlot.start}
        onChange={handleStartChange}
        className="px-3 py-1.5 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg text-sm text-gray-900 dark:text-white focus:ring-2 focus:ring-purple-500 focus:border-transparent"
      />
      <span className="text-gray-500 dark:text-gray-400">〜</span>
      <input
        type="time"
        value={timeSlot.end}
        onChange={handleEndChange}
        className="px-3 py-1.5 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg text-sm text-gray-900 dark:text-white focus:ring-2 focus:ring-purple-500 focus:border-transparent"
      />
      {canRemove && (
        <button
          onClick={onRemove}
          className="p-1.5 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors"
          title="削除"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      )}
    </div>
  )
}
